/**
 * /erm2026/jee — Material para inscripción de listas ERM 2026
 * TEMA LIGHT con paleta del logo (brand-navy + brand-red sobre blanco).
 */
import { ReactNode } from "react";

type Item = {
  titulo: string;
  detalle: string;
  url: string;
  formato: "DOCX" | "MD" | "XLSX" | "PDF";
  kb?: string;
};

const PRESENTACION_URL = "/erm2026/00_PRESENTACION_VERDADELECTORAL_ERM2026.docx";
const PAQUETE_ZIP_URL = "/erm2026/JFT_VERDADELECTORAL_COM_ERM2026.zip";
const PAQUETE_ZIP_MB = "25 MB";

const GUIAS: Item[] = [
  { titulo: "Reglas de inscripción de listas regionales", detalle: "Cómo armar correctamente la fórmula al gobierno regional y la lista al Consejo Regional: cargos, requisitos, paridad de género, cuotas de jóvenes y comunidades, candidatos de libre designación (tope 30%) y tabla maestra de las 26 circunscripciones.", url: "/erm2026/guias/01_Guias_y_Analisis/01_Reglas_Inscripcion_Regional_ERM2026.docx", formato: "DOCX", kb: "23 KB" },
  { titulo: "Reglas de inscripción consolidadas (regional + municipal)", detalle: "Un solo documento con las reglas de ambos niveles para distinguir sus diferencias y aplicarlas en paralelo.", url: "/erm2026/guias/01_Guias_y_Analisis/02_Reglas_Inscripcion_Regional_y_Municipal_ERM2026.md", formato: "MD", kb: "31 KB" },
  { titulo: "Análisis de las normas regionales", detalle: "Contenido y aplicación práctica de las Res. N.° 0001 y 0002-2026-JNE.", url: "/erm2026/guias/01_Guias_y_Analisis/03_Analisis_Normas_Regionales_ERM2026.docx", formato: "DOCX", kb: "30 KB" },
  { titulo: "Análisis de las normas municipales", detalle: "Contenido y aplicación práctica de las Res. N.° 0847 y 0848-2025-JNE.", url: "/erm2026/guias/01_Guias_y_Analisis/04_Analisis_Normas_Municipales_ERM2026.docx", formato: "DOCX", kb: "24 KB" },
  { titulo: "Informe sobre cancelación de inscripción y participación", detalle: "Causales que dejan a una organización o a un candidato fuera del proceso.", url: "/erm2026/guias/01_Guias_y_Analisis/05_Informe_Cancelacion_Inscripcion_ERM2026.docx", formato: "DOCX", kb: "15 KB" },
  { titulo: "Estudio de caso: Huancavelica (EG2026 → aplicación ERM2026)", detalle: "Lectura normativa aplicada a una circunscripción concreta. Incluye precedente Pleno JNE.", url: "/erm2026/guias/01_Guias_y_Analisis/06_Caso_Huancavelica_EG2026_APLICACION_ERM2026.docx", formato: "DOCX", kb: "22 KB" },
];

const CUADROS: Item[] = [
  { titulo: "Cuadro consolidado regional · consejeros y cuotas por circunscripción", detalle: "Tabla maestra con número de consejeros y cuotas por las 26 circunscripciones regionales.", url: "/erm2026/cuadros/02_Cuadros_y_Datos/01_Cuadro_Consolidado_Regionales_ERM2026.xlsx", formato: "XLSX", kb: "41 KB" },
  { titulo: "Cuadro consolidado municipal (Res. 847/848)", detalle: "Regidores y máximo de designados por tipo de concejo provincial y distrital.", url: "/erm2026/cuadros/02_Cuadros_y_Datos/02_Cuadro_Consolidado_Municipales_847_848_ERM2026.xlsx", formato: "XLSX", kb: "42 KB" },
];

const NORMATIVA: Item[] = [
  { titulo: "Res. N.° 0003-2026-JNE — Cronograma electoral ERM2026", detalle: "Fechas oficiales del proceso: inscripción, tachas, resolución JEE, apelación JNE, jornada 4-oct-2026.", url: "/erm2026/normativa/03_Normativa_Oficial_JNE_ONPE/01_Res_0003-2026-JNE_Cronograma_ERM2026.pdf", formato: "PDF", kb: "418 KB" },
  { titulo: "Res. N.° 0001-2026-JNE — Consejeros regionales (número + cuotas)", detalle: "Define cuántos consejeros corresponden a cada gobierno regional y la cuota de comunidades originarias.", url: "/erm2026/normativa/03_Normativa_Oficial_JNE_ONPE/02_Res_0001-2026-JNE_Consejeros_Regionales.pdf", formato: "PDF", kb: "1.6 MB" },
  { titulo: "Res. N.° 0002-2026-JNE — Reglamento de Inscripción Regional", detalle: "Reglamento de inscripción de fórmulas y listas para gobiernos regionales.", url: "/erm2026/normativa/03_Normativa_Oficial_JNE_ONPE/03_Res_0002-2026-JNE_Reglamento_Inscripcion_Regional.pdf", formato: "PDF", kb: "7.1 MB" },
  { titulo: "Res. N.° 0846-2025-JNE — Reglamento DJHV", detalle: "Declaración Jurada de Hoja de Vida (formato, contenido, sanciones por omisión o falsedad).", url: "/erm2026/normativa/03_Normativa_Oficial_JNE_ONPE/04_Res_0846-2025-JNE_Reglamento_DJHV.pdf", formato: "PDF", kb: "2.7 MB" },
  { titulo: "Res. N.° 0847-2025-JNE — Regidores municipales (número + cuotas)", detalle: "Define cuántos regidores corresponden a cada municipalidad provincial y distrital.", url: "/erm2026/normativa/03_Normativa_Oficial_JNE_ONPE/05_Res_0847-2025-JNE_Regidores_Municipales.pdf", formato: "PDF", kb: "2.6 MB" },
  { titulo: "Res. N.° 0848-2025-JNE — Reglamento de Inscripción Municipal", detalle: "Reglamento de inscripción de listas para alcaldías provinciales y distritales.", url: "/erm2026/normativa/03_Normativa_Oficial_JNE_ONPE/06_Res_0848-2025-JNE_Reglamento_Inscripcion_Municipal.pdf", formato: "PDF", kb: "6.2 MB" },
  { titulo: "Res. N.° 0850-2025-JNE — Reglamento de Personeros", detalle: "Regula la acreditación y actuación de personeros (legal, técnico, de mesa y de local).", url: "/erm2026/normativa/03_Normativa_Oficial_JNE_ONPE/07_Res_0850-2025-JNE_Reglamento_Personeros.pdf", formato: "PDF", kb: "2.7 MB" },
  { titulo: "RJ N.° 000187-2025-JN/ONPE — Reglamento de Primarias", detalle: "Reglamento de elecciones primarias para selección de candidatos al interior de las organizaciones políticas.", url: "/erm2026/normativa/03_Normativa_Oficial_JNE_ONPE/08_RJ_000187-2025-JN-ONPE_Reglamento_Primarias.pdf", formato: "PDF", kb: "1.9 MB" },
  { titulo: "JNE — Competencias en elecciones primarias", detalle: "Documento marco sobre competencias del JNE durante el proceso de elecciones primarias.", url: "/erm2026/normativa/03_Normativa_Oficial_JNE_ONPE/09_JNE_Competencias_Primarias.pdf", formato: "PDF", kb: "2.7 MB" },
  { titulo: "Caso APP-Huancavelica · Resolución JEE 00822-2025-JEE-HVA-JNE", detalle: "Precedente del JEE Huancavelica que aplica el criterio normativo de paridad y alternancia.", url: "/erm2026/normativa/03_Normativa_Oficial_JNE_ONPE/10-Caso_APP-HUANCAVELICA-JEE-DIPUTADOS-RESOLUCION 00822-2025-JEE-HVA-JNE.pdf", formato: "PDF", kb: "187 KB" },
  { titulo: "Caso APP-Huancavelica · Pleno JNE Resolución 00029-2026-JNE", detalle: "Pleno del JNE confirma o modifica el criterio del JEE Huancavelica. Precedente vinculante.", url: "/erm2026/normativa/03_Normativa_Oficial_JNE_ONPE/10_Caso_APP-HUANCAVELICA-PLENO-DIPUTADOS-RESOLUCION 00029-2026-JNE.pdf", formato: "PDF", kb: "366 KB" },
];

const POSTS = [
  { titulo: "Cuadrado · 1080 × 1080", url: "/erm2026/posts/POST_VE_ERM2026_CUADRADO_1080.png" },
  { titulo: "Story vertical · 1080 × 1920", url: "/erm2026/posts/POST_VE_ERM2026_STORY_1080x1920.png" },
  { titulo: "X / horizontal · 1200 × 675", url: "/erm2026/posts/POST_VE_ERM2026_X_1200x675.png" },
];

const formatoChip = (f: string) =>
  ({
    PDF: "bg-brand-red-100 text-brand-red border border-brand-red/30",
    DOCX: "bg-brand-navy-100 text-brand-navy border border-brand-navy/30",
    XLSX: "bg-emerald-100 text-emerald-700 border border-emerald-300",
    MD:   "bg-slate-100 text-slate-700 border border-slate-300",
  } as Record<string, string>)[f] ?? "bg-slate-100 text-slate-700";

export function Erm2026JeePage() {
  return (
    <div className="bg-white text-slate-900">
      {/* Hero institucional */}
      <header className="border-b-4 border-brand-red bg-brand-navy-50">
        <div className="container-prose py-10 md:py-14">
          <div className="flex flex-wrap items-center gap-2 text-xs">
            <span className="inline-flex items-center gap-1 rounded-full bg-brand-navy text-white px-2.5 py-1 font-semibold uppercase tracking-widest">
              ERM 2026
            </span>
            <span className="inline-flex items-center gap-1 rounded-full bg-brand-red text-white px-2.5 py-1 font-semibold uppercase tracking-widest">
              Aporte ciudadano
            </span>
            <span className="inline-flex items-center gap-1 rounded-full border border-brand-navy/30 text-brand-navy px-2.5 py-1 uppercase tracking-widest">
              Material no partidario
            </span>
          </div>
          <h1 className="mt-5 font-serif text-4xl md:text-5xl text-brand-navy leading-tight">
            Inscripción de listas ante los <span className="text-brand-red">JEE</span>
          </h1>
          <p className="mt-3 text-xs uppercase tracking-widest text-brand-navy/70">
            Elecciones Regionales y Municipales 2026 · jornada electoral 4 de octubre de 2026
          </p>
          <p className="mt-5 max-w-3xl text-lg text-slate-700 leading-relaxed">
            El 4 de octubre de 2026 se renuevan en una sola jornada las autoridades de los gobiernos
            regionales y de las municipalidades provinciales y distritales del país. Son{" "}
            <strong className="text-brand-navy">dos elecciones simultáneas</strong>, cada una con
            normativa propia. Este paquete ordena y explica —en lenguaje claro— las reglas oficiales
            y las acompaña con la normativa que las sustenta.
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <a
              href={PAQUETE_ZIP_URL}
              download
              className="inline-flex items-center gap-2 rounded-md bg-brand-red text-white px-5 py-2.5 text-sm font-semibold hover:bg-brand-red-700 transition shadow"
            >
              📦 Descargar paquete completo (ZIP · {PAQUETE_ZIP_MB})
            </a>
            <a
              href={PRESENTACION_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 rounded-md bg-brand-navy text-white px-5 py-2.5 text-sm font-semibold hover:bg-brand-navy-700 transition"
            >
              📄 Solo presentación (DOCX)
            </a>
            <a
              href="#bloque-3"
              className="inline-flex items-center gap-2 rounded-md border-2 border-brand-navy text-brand-navy px-5 py-2.5 text-sm font-semibold hover:bg-brand-navy hover:text-white transition"
            >
              Ir a normativa oficial ↓
            </a>
          </div>
        </div>
      </header>

      <main className="container-prose py-12">
        {/* Disclaimer */}
        <div className="rounded-lg border-l-4 border-brand-red bg-brand-red-50 p-4 text-sm text-slate-800">
          <strong className="text-brand-red">Naturaleza del aporte.</strong> Material no partidario,
          de interés público, construido íntegramente sobre normas oficiales. Tiene carácter
          informativo y de divulgación: <em>no sustituye el texto oficial</em>. Ante cualquier
          discrepancia prevalecen las resoluciones del JNE y la ONPE incluidas en el Bloque 3.
        </div>

        {/* Bloque 1 — Guías */}
        <Bloque numero={1} titulo="Guías y análisis" descripcion="Documentos que explican y aplican la normativa oficial.">
          <Grid items={GUIAS} />
        </Bloque>

        {/* Bloque 2 — Cuadros */}
        <Bloque numero={2} titulo="Cuadros y datos" descripcion="Tablas consolidadas para consulta directa.">
          <Grid items={CUADROS} />
        </Bloque>

        {/* Bloque 3 — Normativa oficial */}
        <Bloque numero={3} titulo="Normativa oficial JNE / ONPE" descripcion="Resoluciones oficiales en PDF. Toda afirmación de las guías es contrastable contra estas fuentes primarias." anchor="bloque-3">
          <Grid items={NORMATIVA} />
        </Bloque>

        {/* Posts visuales */}
        <section className="mt-14">
          <div className="flex items-center gap-3">
            <span className="grid h-8 w-8 place-items-center rounded-full bg-brand-red text-white font-serif text-sm">
              ★
            </span>
            <div>
              <h2 className="font-serif text-2xl text-brand-navy">Difusión · posts para redes sociales</h2>
              <p className="text-sm text-slate-600">Material visual listo para republicar. Resolución de impresión nativa.</p>
            </div>
          </div>
          <div className="mt-5 grid gap-4 md:grid-cols-3">
            {POSTS.map((p) => (
              <a
                key={p.url}
                href={p.url}
                target="_blank"
                rel="noopener noreferrer"
                className="block rounded-lg border-2 border-slate-200 bg-white p-3 hover:border-brand-navy hover:shadow-lg transition"
              >
                <div className="aspect-square overflow-hidden rounded-md bg-slate-50 grid place-items-center border border-slate-200">
                  <img src={p.url} alt={p.titulo} className="max-h-full max-w-full object-contain" loading="lazy" />
                </div>
                <div className="mt-3 text-sm font-semibold text-brand-navy">{p.titulo}</div>
                <div className="text-xs text-slate-500">Click para abrir en tamaño original →</div>
              </a>
            ))}
          </div>
        </section>

        {/* Cita de cierre */}
        <section className="mt-14 rounded-lg border-l-4 border-brand-navy bg-brand-navy-50 p-6">
          <blockquote className="font-serif text-xl text-brand-navy italic leading-relaxed">
            "Quien conoce las reglas no teme la fiscalización: las usa."
          </blockquote>
          <p className="mt-3 text-sm text-slate-700">
            — Una contribución de <strong className="text-brand-navy">verdadelectoral.com</strong> ·
            Autoría técnica: Experto en Temas Electorales · JFT-ASCINSA · ERM 2026
          </p>
        </section>
      </main>
    </div>
  );
}

function Bloque({ numero, titulo, descripcion, anchor, children }: { numero: number; titulo: string; descripcion: string; anchor?: string; children: ReactNode }) {
  return (
    <section id={anchor} className="mt-12 scroll-mt-20">
      <div className="flex items-center gap-3">
        <span className="grid h-10 w-10 place-items-center rounded-full bg-brand-navy text-white font-serif text-lg shadow">
          {numero}
        </span>
        <div>
          <h2 className="font-serif text-2xl text-brand-navy">{titulo}</h2>
          <p className="text-sm text-slate-600">{descripcion}</p>
        </div>
      </div>
      <div className="mt-5">{children}</div>
    </section>
  );
}

function Grid({ items }: { items: Item[] }) {
  return (
    <div className="grid gap-3 md:grid-cols-2">
      {items.map((it) => (
        <a
          key={it.url}
          href={it.url}
          target="_blank"
          rel="noopener noreferrer"
          className="block rounded-lg border-2 border-slate-200 bg-white p-4 hover:border-brand-navy hover:shadow-md transition group"
        >
          <div className="flex items-start justify-between gap-3">
            <h3 className="font-serif text-base text-brand-navy group-hover:text-brand-red leading-snug">
              {it.titulo}
            </h3>
            <span className={`shrink-0 rounded px-2 py-0.5 text-xs font-mono font-semibold ${formatoChip(it.formato)}`}>
              {it.formato}
            </span>
          </div>
          <p className="mt-2 text-sm text-slate-700">{it.detalle}</p>
          {it.kb && <div className="mt-2 text-xs text-slate-500">{it.kb}</div>}
        </a>
      ))}
    </div>
  );
}
